import React from 'react'

export default function Loading() {
  return (
    <div className="ssa__loading">
      <div className="lds-ripple"><div></div><div></div></div>
    </div>
  )
}
